"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _router = require("next/router");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _useAppConfiguration2 = _interopRequireDefault(require("@deosite/app/features/appConfiguration/useAppConfiguration"));
var _agent = require("@deosite/agent");
var _CartProvider = require("../../REST/CartProvider");
var _EPoints = require("../../REST/EPoints");
var _OrdersProvider = require("../../REST/OrdersProvider");
var _MessageHandlerProvider = require("../MessageHandlerProvider");
var _handleAdyenErrorMessage = _interopRequireDefault(require("@deosite/helpers/handleAdyenErrorMessage"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var resultCodes = {
  REFUSED: "Refused",
  ERROR: "Error",
  AUTHORISED: "Authorised",
  RECEIVED: "Received",
  PRESENT_TO_SHOPPER: "PresentToShopper",
  PENDING: "Pending"
};
var actionTypes = {
  REDIRECT: "redirect",
  AWAIT: "await",
  QR_CODE: "qrCode",
  SDK: "sdk",
  THREE_DS: "threeDS2",
  VOUCHER: "voucher"
};
var orderIdCookieName = global.__appConfig__.orderIdCookieName;

// https://docs.adyen.com/plugins/adobe-commerce/set-up-vesion-8/headless-integration/?tab=rest3_1#place-order
var useAdyenCheckout = function useAdyenCheckout() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    form: {}
  };
  var translations = {
    adyenPaymentRefused: (0, _langLibrary["default"])("adyen_error_message")
  };
  var router = (0, _router.useRouter)();
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language,
    domain = _useAppConfiguration.domain;
  var _useCart = (0, _CartProvider.useCart)(),
    truncateCart = _useCart.truncateCart,
    clearCart = _useCart.clearCart;
  var _useEPoints = (0, _EPoints.useEPoints)(),
    clearEPoints = _useEPoints.clearEPoints;
  var _useOrders = (0, _OrdersProvider.useOrders)(),
    removeUserOrders = _useOrders.removeUserOrders;
  var clearCheckoutData = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              clearEPoints();
              _context.next = 3;
              return truncateCart();
            case 3:
              _context.next = 5;
              return removeUserOrders();
            case 5:
              clearCart();
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "checkout_success"
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function clearCheckoutData() {
      return _ref.apply(this, arguments);
    };
  }();
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var getPaymentStatus = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(orderId) {
      var response;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _agent.requests.post("/adyen/orders/payment-status", {
                orderId: orderId
              }, global.__appConfig__.adyenMagentoIntegrationToken, {
                language: language,
                domain: domain
              });
            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", JSON.parse(response));
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function getPaymentStatus(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleAdyenPayment = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3) {
      var orderId, component, paymentStatus;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              orderId = _ref3.orderId, component = _ref3.component;
              _context3.prev = 1;
              _jsCookie["default"].set(orderIdCookieName, orderId);
              _context3.next = 5;
              return getPaymentStatus(orderId);
            case 5:
              paymentStatus = _context3.sent;
              _context3.next = 8;
              return handlePaymentResult({
                paymentStatus: paymentStatus,
                component: component
              });
            case 8:
              return _context3.abrupt("return", paymentStatus);
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);
              (0, _handleAdyenErrorMessage["default"])({
                message: translations.adyenPaymentRefused
              }, component, handleMessage);
            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 11]]);
    }));
    return function handleAdyenPayment(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleAdyenAction = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref5) {
      var action, component;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              action = _ref5.action, component = _ref5.component;
              _context4.prev = 1;
              if (!(action.type === "redirect")) {
                _context4.next = 5;
                break;
              }
              _context4.next = 5;
              return clearCheckoutData();
            case 5:
              component.handleAction(action);
              _context4.next = 11;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              (0, _handleAdyenErrorMessage["default"])({
                message: translations.adyenPaymentRefused
              }, component, handleMessage);
            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 8]]);
    }));
    return function handleAdyenAction(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  var handlePaymentResult = /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref7) {
      var paymentStatus, component;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              paymentStatus = _ref7.paymentStatus, component = _ref7.component;
              if (!paymentStatus.isFinal) {
                _context5.next = 9;
                break;
              }
              if (!(paymentStatus.resultCode === resultCodes.AUTHORISED || paymentStatus.resultCode === resultCodes.RECEIVED || paymentStatus.resultCode === resultCodes.PRESENT_TO_SHOPPER)) {
                _context5.next = 7;
                break;
              }
              _context5.next = 5;
              return clearCheckoutData();
            case 5:
              _jsCookie["default"].remove(orderIdCookieName);
              router.push("/checkout/success");
            case 7:
              _context5.next = 15;
              break;
            case 9:
              if (!paymentStatus.action) {
                _context5.next = 14;
                break;
              }
              _context5.next = 12;
              return handleAdyenAction({
                action: paymentStatus.action,
                component: component
              });
            case 12:
              _context5.next = 15;
              break;
            case 14:
              (0, _handleAdyenErrorMessage["default"])({
                message: translations.adyenPaymentRefused
              }, component, handleMessage);
            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return function handlePaymentResult(_x4) {
      return _ref8.apply(this, arguments);
    };
  }();
  return {
    handleAdyenPayment: handleAdyenPayment
  };
};
var _default = useAdyenCheckout;
exports["default"] = _default;